import { StateSchema } from 'app/config/storeConfig/types';
import { BoxFormDrawerSchema } from '../types';

export const getBoxFormState = (state: StateSchema): BoxFormDrawerSchema => state.boxFormDrawer;
